module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Light.0199b2c.woff";